import React from 'react';
import { Link } from 'react-router-dom';

const CategoriesSection = () => {
  const categories = [
    {
      svg: (
        <svg width="85" height="79" viewBox="0 0 85 79" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M31.9606 2.5V31.2376H2.5V50.7193H31.9606V76.5H53.4613V50.7193H82.5V31.4907L53.4613 31.2376V2.5H31.9606Z" stroke="#87AD9A" strokeWidth="5"/>
        </svg>
      ),
      title: "Medical & Health Care"
    },
    {
      svg: (
        <svg width="88" height="79" viewBox="0 0 88 79" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M23.4606 22.0166L3.81152 39.0935L23.4606 56.1704" stroke="#87AD9A" strokeWidth="5"/>
          <path d="M64.1624 23.6445L83.8115 40.7215L64.1624 57.7984" stroke="#87AD9A" strokeWidth="5"/>
          <path d="M50.1275 2.50098L31.8818 76.501" stroke="#87AD9A" strokeWidth="5" strokeLinecap="round"/>
        </svg>
      ),
      title: "Development & Programming"
    },
    {
      svg: (
        <svg width="82" height="76" viewBox="0 0 82 76" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="24.7725" y="33.7256" width="13.0909" height="35.8064" fill="#87AD9A"/>
          <rect x="2.9541" y="44.4678" width="13.0909" height="25.0645" fill="#87AD9A"/>
          <rect x="46.5908" y="22.9844" width="13.0909" height="46.5484" fill="#87AD9A"/>
          <rect x="68.4092" y="12.2412" width="13.0909" height="57.2903" fill="#87AD9A"/>
          <line x1="2.9541" y1="74" x2="81.4996" y2="74" stroke="#87AD9A" strokeWidth="3"/>
          <path d="M1.5 34.3233L20.4091 20.5975L25.5 25.9684L46.5909 9.85553L51.6818 15.2265L66.9545 3.29102" stroke="#87AD9A" strokeWidth="3" strokeLinecap="round"/>
          <path d="M61.1357 1.5H69.1357V7.46774" stroke="#87AD9A" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      ),
      title: "Marketing & Sales"
    },
    {
      svg: (
        <svg width="105" height="105" viewBox="0 0 105 105" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="105" height="105" fill="#87AD9A" />
        </svg>
      ),
      title: "Business Management"
    },
    {
      svg: (
        <svg width="80" height="74" viewBox="0 0 80 74" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M49.1426 74.001H79.9994V65.7472C79.9994 62.9858 77.7609 60.7472 74.9994 60.7472H54.1426C51.3812 60.7472 49.1426 62.9858 49.1426 65.7472V74.001Z" fill="#87AD9A"/>
          <path d="M4.49147 57.7143C2.73901 55.6128 3.15056 52.5882 5.41069 50.9587L28.5263 34.2931L37.6318 45.2122L14.5161 61.8778C12.256 63.5073 9.00312 63.1246 7.25066 61.0231L4.49147 57.7143Z" fill="#87AD9A"/>
        </svg>
      ),
      title: "Lawyer"
    },
    {
      svg: (
        <svg width="83" height="77" viewBox="0 0 83 77" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M28.2119 19.2292V2.5C28.2119 1.94771 28.6596 1.5 29.2119 1.5H80.4998C81.0521 1.5 81.4998 1.94772 81.4998 2.5V46.7502C81.4998 47.3024 81.0521 47.7502 80.4998 47.7502H66.9004" stroke="#87AD9A" strokeWidth="3" strokeLinecap="round"/>
          <path d="M40.6211 17.6875H64.7101" stroke="#87AD9A" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      ),
      title: "Teacher"
    }
  ];

  return (
    <section className="categories">
      <div className="container">
        <h2>Build Resumes for Every Profession</h2>
        <p>Choose your Category and start Building today</p>

        <div className="category-list">
          {categories.map((category, index) => (
            <div className="category-item" key={index}>
              {category.svg}
              <h4>
                {category.title.split(" & ").map((part, i) => (
                  <React.Fragment key={i}>
                    {part}
                    {i < category.title.split(" & ").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </h4>
            </div>
          ))}
        </div>

        <Link to="/profession" className="btn">
          View all Categories →
        </Link>
      </div>
    </section>
  );
};

export default CategoriesSection;
